export default "__VITE_ASSET__7t9eBnZg__"